import React, { useEffect, useRef } from 'react';
import './CountriesSection.css';

const countries = [
  { name: 'UNITED STATES', image: '/maps/map1.webp' },
  { name: 'EUROPE', image: '/maps/map2.webp' },
  { name: 'MIDDLE EAST', image: '/maps/map3.webp' },
  { name: 'REST OF THE WORLD', image: '/maps/map4.webp' },
];

const CountriesSection = () => {
  const cardRefs = useRef([]);
  const scrollY = useRef(window.scrollY);
  const isMobile = useRef(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      isMobile.current = window.innerWidth <= 768;
    };

    window.addEventListener('resize', handleResize);

    if (!isMobile.current) {
      const animate = () => {
        const currentY = window.scrollY;
        scrollY.current = currentY;

        cardRefs.current.forEach((card, index) => {
          if (!card) return;
          const waveOffset = Math.sin(index + currentY * 0.01) * 15;
          card.style.transform = `translateY(${waveOffset}px)`;
        });

        requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
      return () => {
        window.removeEventListener('resize', handleResize);
        cancelAnimationFrame(animate);
      };
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="countries-section">
      <div className="container">
        <div className="countries-header">
          <h2>We are a <br />
            <span className="blue-text">GLOBAL PARTNER IN <br /> OVER 80 COUNTRIES</span>
          </h2>
          <p>Bridging borders, serving clients in over 80 countries worldwide.</p>
        </div>

        <div className="country-grid">
          {countries.map((country, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              className="country-card"
            >
              <img src={country.image} alt={country.name} className="country-icon" />
              <h4>{country.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CountriesSection;